/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-03 13:38:46
 * @LastEditors: linxi
 * @LastEditTime: 2024-05-27 11:06:39
 */
import * as S from "./recipe"

export enum Checks {
  Tybl = 1,
  Zybl = 2,
  Kqbl = 3,
  Ymbl = 4,
  Sssq = 5,
  Ssws = 6,
}

export const CheckOptions = [
  Checks.Tybl,
  Checks.Zybl,
  Checks.Kqbl,
  Checks.Ymbl,
  Checks.Sssq,
  Checks.Ssws,
]

export function getCheckName(diagnoses: Checks, tenantCategory?: any) {
  switch (diagnoses) {
    case 1:
      return "通用病历"
    case 2:
      return tenantCategory == 16 ? '盲人病历' : '中医病历'
    case 3:
      return "口腔病历"
    case 4:
      return "医美病历"
    case 5:
      return "手术申请"
    case 6:
      return "手术文书"
    default:
      break
  }
}

export enum shopCheck {
  Sc = 1,
}

export const shopOptions = [shopCheck.Sc]

export function getShopName(state: shopCheck) {
  switch (state) {
    case 1:
      return "启用"
    default:
      break
  }
}

export enum Checks {
  Zdblsz = 1, //选择要开通的病历  
  Mrcfsz = 2, //开方时默认自动创建处方
  Sc = 3, //商城
  BLFX = 4, //病历诊断风险提示
  SRFSZ = 5, //输入法设置
  MRBL = 6, //选择一个默认病历
  XCXQX = 7, //小程序权限
  MRts = 8, //中药默认帖数
  Ewfy = 9, //开方自动生成额外费用
  Hbfz = 11, //开方同步同组药品的频次/用法/天数
  FPXZ = 12,
  TLXCFHBBHB = 13, //同类型处方合并不合并
  JSHZDTDYYL = 14, //结算后自动跳打印预览
  XZYKTDCF = 15, //选择要开通的处方
  JSHYMTZ = 16, //结算后页面跳转
  GHLB = 1000, //偏好挂号类别
  HZXB = 1001, //偏好自费患者性别
  HZLY = 1002, //偏好患者来源
  KSYS = 1003, //偏好科室医生
  KSKDGHLX = 2000, //快速开单偏好挂号类型
  KSKDHZXB = 2001, //快速开单偏好性别
  KSKDXZCF = 2002, //快速开单偏好默认选择处方
  KSKDKFLX = 2003, //快速开单偏好默认选中开方类型
  KSKDMRTS = 2004, //快速开单偏好中药方默认帖数
}

export const CheckOptionList = [Checks.Zdblsz, Checks.Mrcfsz, Checks.Sc]

export const CheckNames = ['诊断病历设置', '默认处方设置', '商城']

export interface Settinglable {
  code?: string
  codeName: string
  tenentId?: string
}

export const TemPlateOption = [
  Checks.Tybl,
  Checks.Zybl,
  Checks.Kqbl,
]
export const PreferencesSet = [
  Checks.Tybl,
  Checks.Zybl,
  Checks.Kqbl,
  Checks.Ymbl,
]

export const ToothOption = [Checks.Kqbl]

export const getTemPlateName = (diagnoses: Checks, tenantCategory?: any) => {
  switch (diagnoses) {
    case 1:
      return "通用病历"
    case 2:
      return tenantCategory == 16 ? '盲人病历' : '中医病历'
    case 3:
      return "口腔病历";
    case 4:
      return "医美病历";
  }
}



// 微诊所
export enum clinicChecks {
  YYBB = 1,
  HZBL = 2,
  ZXWZ = 3,
  KFGL = 4,
  YJFZ = 5,
  WJJB = 6,
}

export const clinicCheckOptions = [
  clinicChecks.YYBB,
  clinicChecks.HZBL,
  clinicChecks.ZXWZ,
  clinicChecks.KFGL,
  clinicChecks.YJFZ,
  clinicChecks.WJJB,
]

export function getClinicCheckName(diagnoses: clinicChecks) {
  switch (diagnoses) {
    case 1:
      return "运营报表"
    case 2:
      return "患者病历"
    case 3:
      return "在线问诊"
    case 4:
      return "库房管理"
    case 5:
      return "预检分诊"
    case 6:
      return "卫监警报"
    default:
      break
  }
}
